









import { Component, Prop, Vue } from "vue-property-decorator";
import ECPSigner from "@/components/ui/ECPSigner.vue";
import { SignService } from "@/services/sign.service";
import { BaseModule } from "@/store/base.module";
import { RequestsModule } from "@/store/requests.module";
import { RequestsDTO } from "../../../lib/requests.type";
import { AuthModule } from "@/store/auth.module";
import { translate } from "@/utils";
import { NCALayerModes } from "@/config/consts";

@Component({
  components: { ECPSigner },
})
export default class SignRequest extends Vue {
  @Prop()
  private item: number;
  $refs: {
    ecpSingerRef: ECPSigner;
  };

  get user() {
    return AuthModule.user as IUser;
  }

  async sign() {
    const fileData = await RequestsModule.getAttachmentByCodeName({
      CCRID: this.item,
      CodeName: "attach_contract_signed",
    });
    const byteOffset = 0;
    const b = new Blob([
      new Uint8Array(fileData.attach_file.data, byteOffset, length),
    ]);
    const html: string = await b.text();
    const base64: string = btoa(unescape(encodeURIComponent(html)));
    const signResult = await this.$refs.ecpSingerRef.sign(base64, {
      signKey: "SIGNATURE",
      signMethod: "createCMSSignatureFromBase64" as NCALayerModes,
    }); // 2

    if (!signResult) return;
    //Проверка на отозванность и прочее
    const { result: v_result, message: v_message } =
      await SignService.validateEDS(
        signResult as string,
        "SIGNATURE",
        this.user.bin,
      );
    if (!v_result) {
      return BaseModule.showMessage({
        message: translate(v_message as ApiMessageObject).name as string,
        color: "error",
      });
    }
    const formData = new FormData();
    formData.append("file", new Blob([signResult as string]));

    await RequestsModule.uploadfileByCodeName({
      attatchment_type_code: "attach_contractors_sign",
      RID: this.item,
      data: formData,
    });

    await RequestsModule.sendReqToSigned({
      CCRID: this.item,
    });

    this.loadTable();
  }

  get listPagination() {
    return RequestsModule.listPagination;
  }

  async loadTable() {
    if (this.user && this.user.record_id) {
      RequestsModule.setloading();
      const req: RequestsDTO = new RequestsDTO();
      req.CRID = this.user.record_id;
      req.iLimit = this.listPagination.itemsPerPage;
      req.iOffset =
        this.listPagination.itemsPerPage * (this.listPagination.page - 1);
      RequestsModule.loadRequestsList(req);
    }
  }

  extractSignature(
    parsedJSON: { [key: string]: any },
    documentRootName: string = "actDocument",
  ): string {
    // определяем количество подписей
    const signaturesLength = parsedJSON.actDocument["ds:Signature"].length;
    return parsedJSON[documentRootName]["ds:Signature"][signaturesLength - 1][
      "ds:SignatureValue"
    ][0];
  }
}
